import { render, staticRenderFns } from "./sendContentComponent.vue?vue&type=template&id=7075d2c3&scoped=true"
import script from "./sendContentComponent.vue?vue&type=script&lang=js"
export * from "./sendContentComponent.vue?vue&type=script&lang=js"
import style0 from "./sendContentComponent.vue?vue&type=style&index=0&id=7075d2c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7075d2c3",
  null
  
)

export default component.exports